import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsSkiNormalMedium = React.forwardRef(
  ({ color = "currentColor", size = 32, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M16 11.263L10.585 1.38C9.719-.2 7.44-.173 6.613 1.427l-.745 1.44a5.25 5.25 0 00.059 4.934l5.983 10.926L5.65 30.15A1.25 1.25 0 006.747 32h5.334c.456 0 .877-.249 1.096-.65L16 26.197l2.823 5.155c.22.4.64.65 1.096.65h5.334a1.25 1.25 0 001.096-1.851L20.09 18.727l5.984-10.926a5.25 5.25 0 00.058-4.933l-.745-1.44c-.828-1.6-3.106-1.628-3.972-.048zM18.995 11l4.387-8.007.53 1.023a2.75 2.75 0 01-.031 2.585L21.47 11zm-1.57 2.864l.2-.364h2.477l-1.437 2.626zm-2.85 9.73L11.34 29.5H8.858l4.477-8.17zM13.005 11H10.53l-2.41-4.4a2.75 2.75 0 01-.03-2.584l.529-1.023zm1.37 2.5l2.192 4h-2.479l-2.19-4zm6.285 16L15.457 20h2.48l5.205 9.5z"
        fill=""
      />
    </svg>
  )
);
SvgSportsSkiNormalMedium.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsSkiNormalMedium;
